import { LearningCoreRestCRUDService } from '../common/LearningCoreRestCRUDService';
import { IUnitModel } from '../unit/interface/IUnitModel';
import { IContentTransferService } from './IContentTransferService';



export class RestContentTransferService
  extends LearningCoreRestCRUDService<IUnitModel>
  implements IContentTransferService
{
  getEndpoint(): string {
    const url = this.learningConfig.url.api.learning;
    return `${url}/content-import`;
  }

  async getUnitExport(unitId: string, password: string) {
    return await this.request()
    .url(`${this.getEndpoint()}/backup`)
    .errorType('json')
    .post({ unitId, password })
    .error(400, (err: any) => {
      const constraints =
        err?.json?.data?.[0]?.constraints ??
        err?.json?.[0]?.constraints ??
        null;

      const messages = constraints ? Object.values(constraints) : ['Bad Request'];

      const e: any = new Error(messages.join('; '));
      e.name = 'ValidationError';
      e.messages = messages;
      e.payload = err?.json;
      throw e;
    })
    .res(r => r.blob()); 
  }

  async importUnit(file: File, password: string, withDependencies: boolean) {
    const form = new FormData();
    form.append('file', file);
    form.append('password', password);
    form.append('withDependencies', withDependencies ? 'true' : 'false');

    const response = await fetch(`${this.getEndpoint()}/import`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      },
      body: form,
    });

    const result = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }

    return result;
  }
  async importBatch(files: File[], password: string, withDependencies: boolean) {
    const form = new FormData();
    files.forEach((file) => form.append('files', file));
    form.append('password', password);
    form.append('withDependencies', withDependencies ? 'true' : 'false');

    const response = await fetch(`${this.getEndpoint()}/import-batch`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
      },
      body: form,
    });

    const result = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(
        result?.message || `Batch upload failed: ${response.status} ${response.statusText}`,
      );
    }

    return result;
  }
}
